import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

const initialOrderState = {
  error: null,
  isFavorite: false,
  isEdit: false,
  isView: false,
  isAddNew: false,
  isAsesmentChnage: false,
  data: {},
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const labOrderSlice = createSlice({
  name: "labOrder",
  initialState: initialOrderState,
  reducers: {
    setOrder: (state, action) => {
      const {
        data = {},
        isFavorite = false,
        isEdit = false,
        isAddNew = false,
        isView = false,
        isAsesmentChnage = false,
      } = action.payload;
      return {
        ...state,
        data: data,
        isFavorite: isFavorite,
        isEdit: isEdit,
        isView: isView,
        isAddNew: isAddNew,
        isAsesmentChnage: isAsesmentChnage
      };
    },

  },
});

export const { setOrder } = labOrderSlice.actions;
